import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import CommentIcon from "@atlaskit/icon/core/comment";
import PersonIcon from "@atlaskit/icon/core/person";
import RoadmapsPlanIcon from "@atlaskit/icon-lab/core/roadmaps-plan";

import { useUserContext } from "@/components/user-context/user-context-provider";
import { Link } from "@/libraries/design/components";
import { ContentTypeImage } from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/content-type-image.tsx";
import type {
    TabProps,
    TabType
} from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/tab-type.tsx";

import { tabbedHeroSectionRoadmapMessages } from "../reusable-xflow-hero-component/tabbed-hero-section.messages.tsx";

type RoadmapContentTypeProps = TabProps;

export const RoadmapContentType: TabType = ({}: RoadmapContentTypeProps) => {
    const intl = useIntl();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { user } = useUserContext();

    return (
        <ContentTypeImage
            imageSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/52hxc2u4jyp725y2bvn7643d5v5si26i.webp"
            imageAlt="This is an image of Jira Product Discovery's roadmap."
            title={intl.formatMessage(
                tabbedHeroSectionRoadmapMessages.contentTitle
            )}
            description={intl.formatMessage(
                tabbedHeroSectionRoadmapMessages.contentDescription
            )}
            hideSeparator={true}
            iconCollection={[
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionRoadmapMessages.contentFeaturePoint1
                    ),
                    icon: <RoadmapsPlanIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionRoadmapMessages.contentFeaturePoint2
                    ),
                    icon: <CommentIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionRoadmapMessages.contentFeaturePoint3
                    ),
                    icon: <PersonIcon label="" />
                }
            ]}
            cta={
                // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
                <Link
                    href={"/software/jira/product-discovery"}
                    text={intl.formatMessage(
                        tabbedHeroSectionRoadmapMessages.contentCta
                    )}
                    type={"primary"}
                    dataEventProps={{
                        "data-product-key": "jiraProductDiscovery",
                        "data-event-component": "linkButton",
                        "data-event-container": "tabsMenu",
                        "data-event": "clicked",
                        "data-label": "try-it-out",
                        "data-label-english": "Explore Jira Product Discovery",
                        "data-track-event": "jpd-pt.content-types.roadmap.cta"
                    }}
                    onClick={() => {
                        createAnalyticsEvent({
                            eventName: "jpd-crossflow-tab-cta-clicked",
                            eventType: "ui",
                            action: "clicked",
                            actionSubject: "linkButton",
                            actionSubjectId: "jpdCrossFlowHeroSection",
                            attributes: {
                                reactComponent: "RoadmapContentType",
                                tab: "roadmap",
                                userTeamType:
                                    user["extended_profile"]?.team_type
                            }
                        }).fire();
                    }}
                />
            }
            reverseLayout
        />
    );
};
